import { FC } from 'react'

import styled from 'styled-components'
import { Control, Controller } from 'react-hook-form'

import { IconButton } from 'src/Components/Button/IconButton.tsx'
import { Input } from 'src/Components/Input/index.tsx'
import { Select } from 'src/Components/Select'
import { SegmentedControl } from 'src/Components/Input/SegmentedControl.tsx'
import { colors, device } from 'src/Helpers/constants.ts'
import IconCirclePlus from 'src/Assets/addButton.svg?react'
import { UserStatus } from 'src/Redux/api/usersApi.ts'

import { roleFilterOptions, statusLabels } from './constants.ts'
import { SearchUserFormData } from './index.tsx'

const ControlsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 17px;
  flex-wrap: wrap;
`

const StyledInput = styled(Input)`
  width: 320px;
  input {
    border: 1px solid ${colors.secondGray};
    color: ${colors.thirdBlue};
    --input-placeholder-color: ${colors.thirdBlue};
  }

  @media ${device.tabletMax} {
    width: 100%;
  }
`

const StyledSelect = styled(Select)`
  width: 200px;
`

const StyledButton = styled(IconButton)`
  svg {
    path {
      fill: ${colors.fourthBlue};
    }
  }
`

interface SearchBlockProps {
  onOpenAddModal: () => void
  control: Control<SearchUserFormData>
  roleFilter: string
  onRoleFilterChange: (value: string) => void
  statusFilter: UserStatus
  onStatusFilterChange: (value: UserStatus) => void
}

export const SearchBlock: FC<SearchBlockProps> = ({
  onOpenAddModal,
  control,
  roleFilter,
  onRoleFilterChange,
  statusFilter,
  onStatusFilterChange,
}) => {
  return (
    <ControlsContainer>
      <StyledButton
        onClick={onOpenAddModal}
        tooltiptext={'Добавить пользователя'}
        data-testid='add-user'
      >
        <IconCirclePlus />
      </StyledButton>

      <Controller
        name='searchString'
        control={control}
        render={({ field }) => (
          <StyledInput placeholder='Найти пользователя' {...field} />
        )}
      />

      <StyledSelect
        placeholder='Роль'
        data={roleFilterOptions}
        value={roleFilter}
        onChange={(value) => onRoleFilterChange(value || '')}
      />

      <SegmentedControl
        value={statusFilter}
        onChange={(value) => onStatusFilterChange(value as UserStatus)}
        data={[
          { value: UserStatus.ACTIVE, label: statusLabels[UserStatus.ACTIVE] },
          {
            value: UserStatus.ARCHIVED,
            label: statusLabels[UserStatus.ARCHIVED],
          },
        ]}
      />
    </ControlsContainer>
  )
}
